import { FetchProductsRoutine, DeleteProductRoutine, CreateProductRoutine } from '../redux-routines';
import type { IPayloadAction, IProduct, TProductsListState } from '../interfaces';

export const initialState: TProductsListState = {
  isFetching: false,
  data: [],
  error: null,
};

export const productsListReducer = (
  state: TProductsListState = initialState,
  action: IPayloadAction,
): TProductsListState => {
  switch (action.type) {
    case FetchProductsRoutine.REQUEST:
    case CreateProductRoutine.REQUEST:
    case DeleteProductRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FetchProductsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload as IProduct[],
        error: null,
      };
    case CreateProductRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: [...state.data, action.payload as IProduct],
      };
    case DeleteProductRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
      };
    case CreateProductRoutine.FAILURE:
    case FetchProductsRoutine.FAILURE:
    case DeleteProductRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload as Error,
      };
    default:
      return state;
  }
};
